import { useState } from "react";

interface TopBarProps {
  baslik: string;
  altBaslik?: string;
  onHamburgerClick: () => void;
  sidebarCollapsed?: boolean;
}

export default function TopBar({ baslik, altBaslik, onHamburgerClick, sidebarCollapsed }: TopBarProps) {
  const [aramaAcik, setAramaAcik] = useState(false);
  const [bildirimAcik, setBildirimAcik] = useState(false);

  return (
    <header
      className={`fixed top-0 right-0 h-16 flex items-center px-4 md:px-6 z-30 transition-all duration-300
        left-0 lg:left-64 ${sidebarCollapsed ? "lg:left-16" : "lg:left-64"}
      `}
      style={{
        backgroundColor: "#0a0c12",
        borderBottom: "1px solid #1e2130",
      }}
    >
      {/* Hamburger - sadece mobilde */}
      <button
        onClick={onHamburgerClick}
        className="w-9 h-9 flex items-center justify-center rounded-lg mr-3 cursor-pointer lg:hidden flex-shrink-0 transition-colors"
        style={{ backgroundColor: "#141720", color: "#8b8fa8" }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1e2130")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#141720")}
      >
        <i className="ri-menu-line text-lg"></i>
      </button>

      <div className="flex items-center gap-2 flex-1 min-w-0">
        <div className="min-w-0">
          <h1 className="text-sm md:text-base font-bold truncate" style={{ color: "#e8eaf0" }}>{baslik}</h1>
          {altBaslik && <p className="text-xs hidden sm:block" style={{ color: "#4a5068" }}>{altBaslik}</p>}
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
        {/* Arama - masaüstünde genişleyebilir */}
        <div
          className={`hidden sm:flex items-center gap-2 rounded-full transition-all duration-300 ${aramaAcik ? "w-48 md:w-64 px-4 py-2" : "w-9 h-9 justify-center"}`}
          style={{ backgroundColor: "#141720" }}
        >
          <button
            onClick={() => setAramaAcik(!aramaAcik)}
            className="w-4 h-4 flex items-center justify-center cursor-pointer flex-shrink-0"
            style={{ color: "#4a5068" }}
          >
            <i className="ri-search-line text-base"></i>
          </button>
          {aramaAcik && (
            <input
              type="text"
              placeholder="Ara..."
              className="bg-transparent text-sm outline-none flex-1 min-w-0"
              style={{ color: "#c8cad8" }}
              autoFocus
            />
          )}
        </div>

        {/* Bildirimler */}
        <div className="relative">
          <button
            onClick={() => setBildirimAcik(!bildirimAcik)}
            className="w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer relative"
            style={{ backgroundColor: "#141720", color: "#4a5068" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1e2130")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#141720")}
          >
            <i className="ri-notification-3-line text-base"></i>
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          {bildirimAcik && (
            <div
              className="absolute right-0 top-11 w-72 md:w-80 rounded-xl z-50 overflow-hidden"
              style={{ backgroundColor: "#141720", border: "1px solid #1e2130" }}
            >
              <div className="px-4 py-3" style={{ borderBottom: "1px solid #1e2130" }}>
                <p className="text-sm font-semibold" style={{ color: "#c8cad8" }}>Bildirimler</p>
              </div>
              {[
                { mesaj: "Yeni başvuru: Ahmet Yılmaz", zaman: "2 dk önce", ikon: "ri-user-add-line", renk: "#7c3aed", bg: "rgba(124,58,237,0.15)" },
                { mesaj: "WhatsApp tıklaması: Fatma Kaya", zaman: "8 dk önce", ikon: "ri-whatsapp-line", renk: "#10b981", bg: "rgba(16,185,129,0.15)" },
                { mesaj: "Yeni reklam talebi geldi", zaman: "1 saat önce", ikon: "ri-megaphone-line", renk: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
              ].map((b, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 px-4 py-3 cursor-pointer transition-colors"
                  style={{ color: "#8b8fa8" }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.04)")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: b.bg }}
                  >
                    <i className={`${b.ikon} text-sm`} style={{ color: b.renk }}></i>
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm" style={{ color: "#c8cad8" }}>{b.mesaj}</p>
                    <p className="text-xs mt-0.5" style={{ color: "#4a5068" }}>{b.zaman}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Tarih - sadece md+ */}
        <div
          className="hidden md:flex items-center gap-2 rounded-full px-3 py-2"
          style={{ backgroundColor: "#141720" }}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-line text-sm" style={{ color: "#4a5068" }}></i>
          </div>
          <span className="text-xs whitespace-nowrap" style={{ color: "#5a5f7a" }}>3 Nisan 2025</span>
        </div>
      </div>
    </header>
  );
}
